/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { OffersStep } from 'legacy/events/offers.types';
import React, { useState } from 'react';
import Header from 'legacy/common/components/wysiwyg-form/Header';
import CreateOfferPage from './CreateOfferPage';
import OfferDetailPage from './OfferDetailPage';
import OfferListMVP from './OfferListMVP';
import { useEventEditorContext } from '../../../contexts/EventEditorContext';

export const offersStepMap = {
  [OffersStep.CREATE_OFFER]: CreateOfferPage,
  [OffersStep.OFFERS_LIST]: OfferListMVP,
  [OffersStep.EDIT_OFFER]: CreateOfferPage,
  [OffersStep.OFFER_DETAILS]: OfferDetailPage
};

const getOffersStepTitle = (offersStep: OffersStep) => {
  switch (offersStep) {
    case OffersStep.CREATE_OFFER:
      return 'New Offer';
    case OffersStep.OFFERS_LIST:
      return 'Offers';
    case OffersStep.EDIT_OFFER:
      return 'Edit Offer';
    case OffersStep.OFFER_DETAILS:
      return 'Offer Details';
    default:
      return 'Offers';
  }
};

const OffersPage = () => {
  const {
    eventId,
    offersStep,
    setOffersStep,
    handleOfferBackNavigation,
    isDraft,
    isEditing,
    isLoading,
    lastUpdated,
    handleBack,
    navigateToEventSettings
  } = useEventEditorContext();

  const [offerId, _] = useState<string>(undefined);

  const OffersStepComponent = offersStepMap[offersStep];
  return (
    <>
      <Header
        isDraft={isDraft}
        isEditing={isEditing}
        title={getOffersStepTitle(offersStep)}
        isLoading={isLoading}
        lastUpdated={lastUpdated}
        onBack={handleBack}
        onMenuClick={navigateToEventSettings}
      />
      <OffersStepComponent
        offerId={offerId}
        eventId={eventId}
        onClose={handleOfferBackNavigation}
        step={offersStep}
        setOffersStep={setOffersStep}
      />
    </>
  );
};

export default OffersPage;
